<template>
    <!--弹窗-->
    <el-dialog
        width="800px"
        class="media_dialog"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
        :close-on-click-modal="false"
        top="8vh"
    >
        <el-form v-loading="loading" ref="formData" :model="formData">
            <span style="line-height: 18px !important;">亚马逊商店/市场：</span>
            <el-select
                v-model="us_arr_value"
                ref="carrerSelect"
                style="width: 760px;margin-top: 5px"
                size="mini"
                filterable
                :disabled="inputloading"
                @change="usChange"
            >
                <el-option
                    v-for="item in us_arr"
                    :key="item.us"
                    :label="item.title"
                    :value="item.us"
                    :disabled="item.disabled"
                >
                    <div class="keywords_arr_div">
                        <icon-svg
                            :icon-class="item.us"
                            style="font-size: 24px;margin-right:5px;"
                        ></icon-svg>
                        <span
                            style="font-weight: 700; font-size: 14px;margin-left: 10px;"
                            >{{ item.title }}</span
                        >
                    </div>
                </el-option>
            </el-select>
            <div class="media-txt">请输入亚马逊产品URL或ASIN：</div>
            <el-form-item prop="asin">
                <el-input
                    :disabled="!us_arr_value"
                    v-loading="inputloading"
                    v-model="asin"
                    style="width: 760px;"
                    placeholder="亚马逊产品Url或ASIN"
                    @change="inputChange"
                ></el-input>
            </el-form-item>
            <div class="media" v-if="asinData.image_url">
                <div class="media-left">
                    <img
                        class="media-object"
                        :src="asinData.image_url"
                        alt=""
                    />
                </div>
                <div class="media-body">
                    <span style="word-break: break-word !important;">{{
                        asinData.title
                    }}</span>
                    <div class="media-asin">
                        <span class="product-asin">{{ asinData.asin }}</span>
                    </div>
                </div>
            </div>
            <el-select
                v-if="keywords_arr.length != 0"
                v-model="keywords_arr_value"
                ref="carrerSelect"
                @change="changeselect()"
                style="width: 760px;"
                size="mini"
                filterable
                placeholder="从其他ASIN导入关键字。。。"
            >
                <el-option
                    v-for="item in keywords_arr"
                    :key="item.asin"
                    :label="item.asin"
                    :value="item.asin"
                >
                    <div class="keywords_arr_div">
                        <img
                            :src="item.image_url"
                            alt=""
                            style="width: 30px; height: 30px;margin-top: 2px;"
                        />
                        <span
                            style="font-weight: 700; font-size: 14px;margin-left: 10px;"
                            >{{ item.asin }}</span
                        >
                        <span class="keywords_arr_div_span">{{
                            item.title
                        }}</span>
                    </div>
                </el-option>
            </el-select>
            <div class="media-txt">
                请输入您要监控的关键字或关键短语（每行一个）：
            </div>
            <el-form-item>
                <el-input
                    v-if="checked_str"
                    v-model="str"
                    :rows="15"
                    @input="oninput"
                    onkeyup="value=value.replace(/[^\r\n0-9 a-zA-Z_-]/g,'')"
                    type="textarea"
                    style="width: 760px;"
                    placeholder="输入关键字或关键短语，已换行区分"
                >
                </el-input>
                <el-input
                    v-else
                    v-model="str"
                    :rows="15"
                    @input="oninput"
                    type="textarea"
                    style="width: 760px;"
                    placeholder="输入关键字或关键短语，已换行区分"
                >
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-popover
                    ref="popover"
                    @show="clickFolders"
                    :popper-append-to-body="false"
                    :append-to-body="false"
                    class="button-star"
                    placement="bottom-start"
                    title
                    popper-class="select-popper"
                    trigger="click"
                >
                    <div v-loading="loadingFolders" style="width: 200px;">
                        <div class="dropdown-header">
                            <span>搜索到文件夹：</span>
                        </div>
                        <div style="margin: 0 10px 5px;">
                            <el-input
                                size="small"
                                v-model="nameFolders"
                                @input="inputFolders"
                                style="width: 180px;"
                                placeholder="输入文件夹名称"
                                clearable
                            ></el-input>
                        </div>
                        <div class="dropdown-header">
                            <span class="dropdown-header__title">文件夹</span>
                            <span class="dropdown-header__title">关键词</span>
                        </div>
                        <div
                            v-if="nameFolders.length == 0"
                            class="dropdown-items"
                        >
                            <div
                                v-for="(item, i) in this.arrFolders"
                                :key="i"
                                class="dropdown-item"
                                @click="onkeyword(item)"
                            >
                                <div class="dropdown-item-txt">
                                    {{ item.name }}
                                </div>
                                <span>{{ item.kw_count }}</span>
                            </div>
                        </div>
                        <div
                            v-if="nameFolders.length != 0"
                            class="dropdown-items"
                        >
                            <div
                                v-for="(item, i) in this.arrFolders_search"
                                :key="i"
                                class="dropdown-item"
                                @click="onkeyword(item)"
                            >
                                <span>{{ item.name }}</span>
                                <span>{{ item.kw_count }}</span>
                            </div>
                        </div>
                    </div>
                    <div
                        style="margin: 0 10px;display: inline-block;"
                        slot="reference"
                    >
                        <div class="button-plus">
                            <i
                                class="el-icon-upload2"
                                style="font-size: 14px;color: #6a6c6f !important;"
                            ></i>
                            导入文件夹中的关键词
                        </div>
                    </div>
                </el-popover>
                <div class="pushed-folders">
                    <div
                        class="pushed-keyword"
                        v-for="(item, i) in this.foldersArr"
                        :key="i"
                    >
                        <span>{{ item.name }}</span>
                        <i
                            class="el-icon-close"
                            @click="deleteFoldersKeyword(item)"
                        ></i>
                    </div>
                </div>
            </el-form-item>
            <el-form-item>
                <div class="checked_item" style="line-height: 18px !important;">
                    <div>
                        <el-checkbox
                            v-model="checked_str"
                            @change="change_str"
                        ></el-checkbox>
                        删除特殊字符（，？！&*%$@#，等等）
                    </div>
                    <span
                        >关键字总数：
                        <span style="color: #62cb31 !important;">{{
                            arr.length
                        }}</span>
                        (<span style="color: #3498db !important">{{
                            keywordsIndex - arr.length
                        }}</span
                        >)
                    </span>
                </div>
            </el-form-item>
            <el-form-item>
                <div class="checked_item">
                    <div>
                        <el-checkbox v-model="checked_asin"></el-checkbox>
                        监控父ASIN和所有子ASIN
                    </div>
                </div>
            </el-form-item>
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button style="" size="mini" plain @click="empty()"
                >清 空</el-button
            >
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose(true)"
                >取 消</el-button
            >
            <el-button
                style="float:right"
                size="mini"
                type="primary"
                @click="submitForm('formData')"
                :loading="loading"
                >开始监控</el-button
            >
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/Product/Product";
import { str_arr, str_arr_no_limit } from "@/utils/method";
export default {
    data() {
        return {
            formData: {},
            loading: false,
            loadingFolders: false,
            inputloading: false,
            checked_str: true,
            checked_asin: true,
            keywords_arr: [],
            keywords_arr_value: null,
            us_arr: [
                {
                    us: "US",
                    title: "www.amazon.com"
                },
                {
                    us: "UK",
                    title: "www.amazon.co.uk"
                },
                {
                    us: "DE",
                    title: "www.amazon.de"
                }
                // {
                //     us: "CA",
                //     title: "www.amazon.ca",
                //     disabled: true
                // },
                // {
                //     us: "MX",
                //     title: "www.amazon.mx",
                //     disabled: true
                // },
                // {
                //     us: "ES",
                //     title: "www.amazon.es",
                //     disabled: true
                // },
                // {
                //     us: "FR",
                //     title: "www.amazon.fr",
                //     disabled: true
                // },
                // {
                //     us: "IT",
                //     title: "www.amazon.it",
                //     disabled: true
                // },
                // {
                //     us: "JP",
                //     title: "www.amazon.co.jp",
                //     disabled: true
                // },
                // {
                //     us: "AU",
                //     title: "www.amazon.com.au",
                //     disabled: true
                // },
                // {
                //     us: "SE",
                //     title: "www.amazon.se",
                //     disabled: true
                // },
                // {
                //     us: "NL",
                //     title: "www.amazon.nl",
                //     disabled: true
                // },
                // {
                //     us: "PL",
                //     title: "www.amazon.pl",
                //     disabled: true
                // }
                // {
                //     us: "BR",
                //     title: "www.amazon.com.br"
                // },
                // {
                //     us: "IN",
                //     title: "www.amazon.in"
                // }
            ],
            us_arr_value: "",
            //关键词容器
            arrFolders: [],
            arrFolders_search: [],
            nameFolders: "",
            asinData: {},
            arr: [],
            foldersArr: [],
            asin: "",
            str: ""
        };
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        keywordsIndex: {
            type: Number,
            default: 0
        },
        title: {
            type: String,
            default: ""
        }
    },
    methods: {
        async get_keywords_arr() {
            await api
                .keywords_of_all_asins({
                    country_code: this.us_arr_value
                })
                .then(res => {
                    if (res.code === 0) {
                        this.keywords_arr = res.data;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                });
        },
        // 开始监控
        submitForm() {
            if (this.inputloading) {
                return this.$message({
                    type: "error",
                    message: "正在获取ASIN行，请稍后在提交。"
                });
            }
            if (!this.asinData.asin) {
                return this.$message({
                    type: "error",
                    message: "请输入合法的亚马逊产品URL或ASIN。"
                });
            }
            if (this.arr.length == 0) {
                return this.$message({
                    type: "error",
                    message: "请输入至少一个关键字或关键字短语。"
                });
            }
            if (this.keywordsIndex - this.arr.length < 0) {
                return this.$message({
                    type: "error",
                    message: "您输入的关键词已达到上限!"
                });
            }
            let obj = {};
            obj.asin = this.asinData.asin;
            obj.keywords = this.arr;
            obj.country_code = this.us_arr_value;
            obj.all_sub_asin = this.checked_asin ? 1 : 0;
            this.loading = true;
            api.product_add(obj)
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.$message({
                            message: "开始监控成功",
                            type: "success"
                        });
                        this.handleClose(false);
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.$message({
                        type: "error",
                        message: "网络出现问题，请刷新页面！"
                    });
                });
        },
        //获取文件列表
        clickFolders() {
            this.loadingFolders = true;
            api.kw_folder_all()
                .then(res => {
                    this.loadingFolders = false;
                    if (res.code === 0) {
                        this.arrFolders = res.data;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loadingFolders = false;
                });
        },
        //文件夹搜索
        inputFolders(val) {
            let arr = JSON.parse(JSON.stringify(this.arrFolders));
            let searcharr = [];
            arr.forEach(item => {
                if (item.name.indexOf(val.toLowerCase()) != -1) {
                    searcharr.push(item);
                }
            });
            this.arrFolders_search = searcharr;
        },
        //获取文件夹中的关键词
        onkeyword(data) {
            if (data.kw_count == 0) {
                return this.$message({
                    type: "error",
                    message: "该文件夹下没有关键词！"
                });
            }
            api.keywords_by_id({ folder_id: data.id })
                .then(res => {
                    this.buttonLoading = false;
                    if (res.code === 0) {
                        var arr = this.arr.concat(res.data);
                        this.arr = Array.from(new Set(arr));
                        this.str = this.arr_str(this.arr);
                        this.$refs.popover.showPopper = false;
                        for (let i = 0; i < this.foldersArr.length; i++) {
                            if (this.foldersArr[i].id == data.id) return;
                        }
                        this.foldersArr.push(data);
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.buttonLoading = false;
                });
        },
        //删除
        deleteFoldersKeyword(data) {
            api.keywords_by_id({ folder_id: data.id })
                .then(res => {
                    this.buttonLoading = false;
                    if (res.code === 0) {
                        this.arr = this.getdifferentArr(res.data, this.arr);
                        this.str = this.arr_str(this.arr);
                        for (let i = 0; i < this.foldersArr.length; i++) {
                            if (this.foldersArr[i].id == data.id) {
                                this.foldersArr.splice(i, 1);
                                break;
                            }
                        }
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.buttonLoading = false;
                });
        },
        //数组对比，相差部分
        getdifferentArr(arry1, arry2) {
            var arry3 = [];
            var tmp = arry1.concat(arry2);
            var o = {};
            for (let i = 0; i < tmp.length; i++)
                tmp[i] in o ? o[tmp[i]]++ : (o[tmp[i]] = 1);
            for (let x in o) if (o[x] === 1) arry3.push(x);
            return arry3;
        },
        //清空
        empty() {
            this.str = "";
            this.asin = "";
            this.keywords_arr_value = null;
            this.arr = [];
            this.formData = {};
            this.asinData = {};
            this.checked_str = true;
            this.checked_asin = true;
        },
        usChange() {
            this.keywords_arr = [];
            this.get_keywords_arr();
            if (this.asin.length < 10) return;
            this.inputChange(this.asin);
        },
        //获取ASIN内容数据
        inputChange(val) {
            if (val.length < 10) {
                return this.$message({
                    type: "error",
                    message: "Amazon产品Url或ASIN应至少包含10个字符"
                });
            }
            this.inputloading = true;
            api.asin_info({ asin: val, country_code: this.us_arr_value })
                .then(res => {
                    this.inputloading = false;
                    if (res.code === 0) {
                        this.asinData = res.data;
                        if (res.data.parent_asin != null) {
                            this.$confirm(
                                `检测到该产品的父ASIN（${res.data.parent_asin}）具有其他子变体，是否要监控父ASIN和所有子ASIN?`,
                                "提示",
                                {
                                    confirmButtonText: "是",
                                    cancelButtonText: "否",
                                    type: "warning",
                                    showClose: false,
                                    center: true
                                }
                            )
                                .then(() => {
                                    this.checked_asin = true;
                                    this.asin = res.data.parent_asin;
                                    this.asinData.asin = res.data.parent_asin;
                                })
                                .catch(() => {
                                    this.checked_asin = false;
                                });
                        }
                        if (res.data.sub_asin != null) {
                            this.$confirm(
                                `已检测到该ASIN存在 ${res.data.sub_asin.length}个子ASIN，是否要监控所有子ASIN?`,
                                "提示",
                                {
                                    confirmButtonText: "是",
                                    cancelButtonText: "否",
                                    type: "warning",
                                    showClose: false,
                                    center: true
                                }
                            )
                                .then(() => {
                                    this.checked_asin = true;
                                })
                                .catch(() => {
                                    this.checked_asin = false;
                                });
                        }
                    } else {
                        this.asinData = {};
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.inputloading = false;
                    this.$message({
                        type: "error",
                        message: "网络出现问题，请刷新页面！"
                    });
                });
        },
        // 数组按换行符拼接成字符串
        arr_str(arr) {
            let str = "";
            if (arr.length != 0) {
                for (let i = 0; i < arr.length; i++) {
                    str += arr[i] + "\n";
                }
            }
            return str;
        },
        //选择框方法
        changeselect() {
            let str_asin = null;
            for (let i = 0; i < this.keywords_arr.length; i++) {
                if (this.keywords_arr[i].asin == this.keywords_arr_value) {
                    str_asin = this.arr_str(this.keywords_arr[i].keywords);
                    break;
                }
            }
            if (this.str.length == 0) {
                this.str = str_asin;
                this.oninput(this.str);
            } else {
                this.AddReplacement(str_asin);
            }
        },
        // 是否添加或者替换
        AddReplacement(str_asin) {
            this.$confirm(
                "您已在关键字字段中输入关键字。是否要用导入的短语附加或替换关键字？",
                "提示",
                {
                    confirmButtonText: "附加",
                    cancelButtonText: "替换",
                    type: "warning",
                    showClose: false,
                    center: true
                }
            )
                .then(() => {
                    this.str = this.str + "\n" + str_asin;
                    this.$refs.carrerSelect.blur();
                    this.oninput(this.str);
                })
                .catch(() => {
                    this.str = str_asin;
                    this.$refs.carrerSelect.blur();
                    this.oninput(this.str);
                });
        },
        //单选框方法
        change_str(val) {
            if (val) {
                this.str = this.str.replace(/[^\r\n0-9 a-zA-Z_-]/g, "");
                this.oninput(this.str);
            }
        },
        //输入框方法
        oninput(val) {
            let str = null;
            if (this.checked_str) {
                str = val.replace(/[^\r\n0-9 a-zA-Z_-]/g, "");
                this.arr = str_arr(str);
            } else {
                str = val;
                this.arr = str_arr_no_limit(str);
            }
        },
        // 关闭弹窗
        handleClose(isshow) {
            if (!isshow) {
                this.loading = false;
                this.str = "";
                this.asin = "";
                this.keywords_arr_value = null;
                this.arr = [];
                this.formData = {};
                this.asinData = {};
                this.checked_str = true;
                this.checked_asin = true;
            }
            this.$emit("close-callback", isshow);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.pushed-folders {
    line-height: 19px !important;
    min-height: 28px;
    display: inline-block;
    vertical-align: top;
    border: 1px solid transparent;
}
.pushed-keyword {
    font-size: 14px;
    font-weight: 700;
    color: #343a40;
    display: inline-block;
    vertical-align: middle;
    padding: 3px 7px 3px 3px;
    margin: 5px 5px 0 0;
    border-radius: 4px;
    border: 1px solid #e4e5e7;
    background-color: #fff;
    i {
        margin-left: 5px;
        cursor: pointer;
        font-weight: 700;
    }
}
.dropdown-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 6px 6px 11px;
    font-size: 14px;
    font-weight: 400;
    color: #343a40;
    white-space: nowrap;
    user-select: none;
    cursor: pointer;
    box-sizing: border-box;
    .dropdown-item-txt {
        width: 132px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    span {
        padding-right: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        box-sizing: border-box;
    }
}
.dropdown-item:hover {
    background: rgb(240, 240, 240);
}
.dropdown-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-weight: 700;
    color: #003873;
    line-height: 1.2;
    margin: 0;
    padding: 6px 8px 6px 11px;
    cursor: default;
    user-select: none;
}
.dropdown-header__title {
    font-size: 14px;
    font-weight: 600;
    color: #8c8c8c;
}
.dropdown-items {
    overflow-y: auto;
    min-height: 0;
    max-height: 276px;
    transition: height 400ms cubic-bezier(0.5, 0, 0.2, 1);
}
.select-popper {
    .popper__arrow {
        display: none !important;
    }
    margin-top: 3px !important;
    padding: 5px 0 !important;
    box-sizing: border-box !important;
}
.folder {
    color: #003873;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 6px 6px 11px;
    font-size: 14px;
    font-weight: 700;
    white-space: nowrap;
    user-select: none;
    cursor: pointer;
}
.folder:hover {
    background: rgb(240, 240, 240);
}
.button-plus {
    width: 163px;
    cursor: pointer;
    height: 28px;
    line-height: 28px;
    font-size: 13px;
    padding: 0 5.5px;
    background: #fff;
    box-sizing: border-box;
    border: 1px solid #dcdfe6;
    color: #606266;
    font-weight: 500;
    border-radius: 4px;
}
.keywords_arr_div {
    display: flex;
    align-items: center;
}
.keywords_arr_div_span {
    margin-left: 5px;
    display: inline-block;
    font-size: 13px;
    max-width: 560px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.media {
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;
}
.media-left {
    padding: 4px 8px 4px 4px;
    box-sizing: border-box;
}
.media-object {
    vertical-align: middle;
    border-style: none;
    width: 70px;
    height: 70px;
}
.media-body {
    font-size: 13px;
    color: #6a6c6f;
    flex: 1;
    box-sizing: border-box;
}
.media-asin {
    margin: 4px 0;
    box-sizing: border-box;
}
.product-asin {
    vertical-align: middle;
    font-weight: 700;
}
.media-txt {
    font-size: 13px;
    color: #6a6c6f;
    margin: 10px 0 10px 0;
}
.checked_item {
    display: flex;
    justify-content: space-between;
}
/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}
/deep/ .el-form-item {
    margin-bottom: 6px !important;
}
/deep/ ::-webkit-scrollbar {
    width: 7px;
    height: 5px;
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-track-piece {
    background-color: #ffff;
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-thumb:vertical {
    height: 5px;
    background-color: rgba(144, 147, 153, 0.5);
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-thumb:horizontal {
    width: 7px;
    background-color: rgba(144, 147, 153, 0.5);
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
</style>
